import * as React from 'react';
import styled from 'styled-components';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children?: React.ReactNode;
}

export const PanelButton = ({ children, ...rest }: Props): JSX.Element => {
  return <Button {...rest}>{children}</Button>;
};

const Button = styled.button`
  background: transparent;
  border: none;
  color: ${({ theme }) => theme.palette.textDefault};
`;
